import { atom, useAtom } from "jotai";
import useStore from "../../../../context/useStore";
import { searchClients } from "../../../../services/clientService";
import tools from "../../../../helpers/tools";
import { filtresClientsParDefaut } from "./clientFiltersDefault";

const clientsAtom = atom([]);
const isLoadingClientsAtom = atom(false);
// Valeurs par défaut : ClientList/clientFiltersDefault.js (source unique).
const clientFiltersAtom = atom(filtresClientsParDefaut());
// Vrai dès qu'une recherche a répondu : la ligne de résumé affiche alors le compteur.
const isListInitAtom = atom(false);
const resultCountAtom = atom(0);
const detailedCountAtom = atom({
  users: 0,
  clients: 0,
  policies: 0,
});

const useClientList = () => {
  const [state] = useStore();
  const { ACCOUNT_STATUS, POLICIES_STATUS } = state.constants.items;
  const [clientFilters, setClientFilters] = useAtom(clientFiltersAtom);
  const [clients, setClients] = useAtom(clientsAtom);
  const [resultCount, setResultCount] = useAtom(resultCountAtom);
  const [isLoadingClients, setIsLoadingClients] = useAtom(isLoadingClientsAtom);
  const [detailedCount, setDetailedCount] = useAtom(detailedCountAtom);
  const [isListInit, setIsListInit] = useAtom(isListInitAtom);

  const onGetClients = ({ overrideFilters = null } = {}) => {
    setIsLoadingClients(true);
    const filtresEnvoyes = overrideFilters || clientFilters;
    searchClients(filtresEnvoyes)
      .then((data) => {
        //order policies by product.name
        const formattedData = data.users.map((user) => {
          return {
            ...user,
            clients: user.clients.map((client) => ({
              ...client,
              policies: client.policies.sort((a, b) =>
                a.productType < b.productType ? 1 : -1
              ),
            })),
          };
        });
        const sortedData = tools.orderResults(
          formattedData,
          filtresEnvoyes.user.nomSociete,
          filtresEnvoyes.user.nomPrenomClient
        );
        setClients(sortedData);
        setDetailedCount({
          users: data.count,
          clients: data.users.reduce((a, b) => a + b.clients.length, 0),
          policies: data.users.reduce(
            (a, b) =>
              a + b.clients.reduce((a1, b1) => a1 + b1.policies.length, 0),
            0
          ),
        });
        setResultCount(data.count);
        setIsListInit(true);
      })
      .finally(() => setIsLoadingClients(false));
  };

  const onClientFiltersChange = (newFilters) => {
    setClientFilters(newFilters);
  };

  const updatePage = (page) => {
    const newFilters = {
      ...clientFilters,
      page,
    };
    onGetClients({ overrideFilters: newFilters });
    setClientFilters(newFilters);
  };

  return {
    clients,
    resultCount,
    detailedCount,
    clientFilters,
    isLoadingClients,
    isListInit,
    ACCOUNT_STATUS,
    POLICIES_STATUS,
    actions: { onGetClients, onClientFiltersChange, updatePage },
  };
};

export default useClientList;
